import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import DatePicker from 'react-datepicker';
import Chip from '@material-ui/core/Chip';
import {
   Calendar,
} from 'react-feather';
import { generateKey } from 'util/componentUtil';
import './styles.css';
import withInputErrorMessage from '../withInputErrorMessage';
import withDateListWrapper from './withDateListWrapper';
import {getDateAsLocalDateStr} from "../../../util/dateUtil";

const AddDateButton = forwardRef(
   ({ value, onClick }, ref) => (
      <div
         onClick={onClick}
         ref={ref}
         className='btn-add-date'
      >
         Add Date&nbsp;&nbsp;
         <Calendar size={18}/>
      </div>
   ),
);

const MultiDatePicker = (props) => {
   const handleDelete = useCallback((indexToDelete) => {
      if (
         props.value
         && lodash.isArray(props.value)
         && indexToDelete < props.value.length
      ) {
         props.remove(indexToDelete);
      }
   }, [props.value]);

   return (
      <div>
         <DatePicker
            onBlur={props.onBlur}
            disabledKeyboardNavigation
            className='mb-2'
            placeholderText='Select date'
            disabled={props.isDisabled}
            dateFormat='MM/dd/yyyy'
            customInput={<AddDateButton/>}
            filterDate={props.filterDate}
            excludeDates={props.excludeDates}
            onChange={ (date) => {
               const timeToInsert = (new Date(date)).getTime();
               const indexToInsert = props.value.findIndex((curDate) => {
                  return curDate.getTime() > timeToInsert;
               });

               if (indexToInsert !== -1) {
                  props.insert(indexToInsert, date);
               } else {
                  props.push(date);
               }
            }}
         />
         <div className={`d-flex flex-column ${ props.value?.length > 0 ? 'mt-2' : '' }`}>
            {
               props.value
               && lodash.isArray(props.value)
               && props.value.map((date, index) => {
                  const label = getDateAsLocalDateStr(date);
                  return (
                     <div
                        className='my-1'
                        key={ `${ generateKey('date-picked') }` }
                     >
                        <Chip
                           size='small'
                           label={ label }
                           onDelete={ () => {
                              handleDelete(index);
                           } }
                        />
                     </div>
                  );
               })
            }
         </div>
      </div>
   );
};

MultiDatePicker.propTypes = {
   value: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
   isDisabled: PropTypes.bool,
   filterDate: PropTypes.func,
   excludeDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
   insert: PropTypes.func.isRequired,
   remove: PropTypes.func.isRequired,
   push: PropTypes.func.isRequired,
};

MultiDatePicker.defaultProps = {
   value: [],
   isDisabled: false,
   filterDate: undefined,
   excludeDates: [],
};

export default withDateListWrapper(withInputErrorMessage(MultiDatePicker));
